import {isInPage} from './functions.js';


if(isInPage(document.getElementById("homepage"))){
    var buttons = document.getElementById("js-cat-buttons").getElementsByTagName("li");

    for(let i=0;i < buttons.length;i++){
        var button = document.getElementById(buttons[i].id);
        button.addEventListener("click", function(e){
            var category = this.id.split('-')[0];
            var category_tabs = document.getElementsByClassName("js-product-categories");
            var link = document.getElementById('shop-link');

            for (var j = 0; j<buttons.length; j++) {
                buttons[j].style.backgroundColor = '#f2f1ec';
                buttons[j].style.color = '#1e1e1e';
            }

            var target = e.target;
            target.style.backgroundColor = '#fff';
            target.style.color = '#1e1e1e';

            for(let j=0;j < category_tabs.length;j++){
                if(category_tabs[j].id.split('-')[0] === category)
                    category_tabs[j].style.display = 'block';
                else {
                    category_tabs[j].style.display = 'none';
                }
            }

        }, false);
    }
}
